var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.438 12.39L19 12.844V17.324L16 18.524V11.782C15.471 11.188 14.716 10.285 14 9.21504V18.614L10 17.281V5.38704L12.428 6.19604C12.166 5.46104 12 4.71803 12 4.00004C12 3.98204 12.003 3.96504 12.003 3.94704L8.969 2.93604L3.629 5.07204C3.249 5.22404 3 5.59104 3 6.00004V20C3 20.707 3.714 21.191 4.371 20.929L9.031 19.065L15.031 21.065L20.371 18.929C20.751 18.776 21 18.409 21 18V10.585C20.308 11.465 19.697 12.122 19.438 12.39ZM8 17.323L5 18.523V6.67704L8 5.47704V17.323Z",
    fill: "#737575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C15.791 0 14 1.791 14 4C14 6.857 18 11 18 11C18 11 22 6.857 22 4C22 1.791 20.209 0 18 0ZM18 5.429C17.211 5.429 16.571 4.789 16.571 4C16.571 3.211 17.211 2.571 18 2.571C18.789 2.571 19.429 3.211 19.429 4C19.429 4.789 18.789 5.429 18 5.429Z",
    fill: "#737575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9 4L4 6V20L9 18V4ZM19.438 12.39L18 13.879L16.562 12.39C16.303 12.122 15.692 11.465 15 10.585V20L20 18V11.781C19.758 12.053 19.558 12.266 19.438 12.39Z",
    fill: "#737575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoMap);
export default __webpack_public_path__ + "static/media/geo-map.2ee8380f.svg";
export { ForwardRef as ReactComponent };